import React from "react";
import "./PwdReset.css";
import { connect } from "react-redux";
import { Modal, Button, Alert, Form, FormCheck } from "react-bootstrap";
import { Form as ReactFinalForm, Field } from "react-final-form";
import { pwdResetMailUser } from "../../actions/userActions";
import { isEmail } from "validator";
import { Helmet } from "react-helmet";
import { pageview } from "../../utils/googleAnalyticsUtils";

class PwdResetMail extends React.Component {
  // componentDidMount(){
  //   const token = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).token
  componentDidMount() {
    pageview('Password Reset Mail');
    const token = this.props.match.params.token;
    const userId = this.props.match.params.userId;
  }

  onSubmit = async (values) => {
    await this.props.pwdResetMailUser(values.email);
  };

  required = (v) => (v ? undefined : "Required");
  email = (v) =>
    v && isEmail(v.toString()) ? undefined : "Invalid Email Address";
  maxLength = (max) => (v) =>
    v && v.length > max ? `Must be ${max} characters or less` : undefined;
  minLength = (min) => (v) =>
    v && v.length < min ? `Must be ${min} characters or more` : undefined;
  composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  render() {
    return (
      <div className="prm-container">
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        <div className="prm-text-container">
          <p className="prm-text">
            Please enter the email associated with your account for which you
            have to reset your password
          </p>
          <ReactFinalForm
            onSubmit={this.onSubmit}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              return (
                <form onSubmit={handleSubmit}>
                  {this.props.error && (
                    <Alert variant="danger">
                      <p>{this.props.error}</p>
                    </Alert>
                  )}

                  <Field
                    name="email"
                    validate={this.composeValidators(
                      this.required,
                      this.email,
                      this.minLength(1),
                      this.maxLength(255)
                    )}
                  >
                    {({ input, meta }) => (
                      <div>
                        <Form.Group className="mb-3">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            {...input}
                            type="Email"
                            placeholder="Enter your email"
                            name="email"
                            autofocus
                          />
                        </Form.Group>
                      </div>
                    )}
                  </Field>

                  <button
                    className="btn btn-warning"
                    style={{ marginTop: "15px" }}
                    type="submit"
                  >
                    Submit
                  </button>
                </form>
              );
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.userPwdReset.loading,
    error: state.userPwdReset.error,
  };
};
export default connect(mapStateToProps, { pwdResetMailUser })(PwdResetMail);
